import React from "react";
import { Modal, ModalBody, modalConnect } from "@modal";
import { ceModalDownloadContentCancel } from "@js/actions/studio/campaign_content_section/modal_download_content.js";

const ModalDownloadContent = modalConnect((props) => {
  return (
    <Modal
      title={t("phrases.react_content.downloading_content")}
      onCancel={() => props.dispatch(ceModalDownloadContentCancel())}
    >
      <ModalBody>{t("phrases.react_content.waiting_for_download")}</ModalBody>
    </Modal>
  );
});

export default ModalDownloadContent;
